import React, { useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Header from '../../../../../policy/fragments/heading/index';
import { useRef } from "react";
import { useIntl } from "react-intl";
import { Link, useLocation } from "react-router-dom";
import Affix from "../../../../../../components/affix";

const PointsHistoryTab = props =>{
    const Intl = useIntl();
    const location = useLocation();
    const initDataRef = useRef([
        {
            id:1,
            title: Intl.formatMessage({ id: "all", defaultMessage: "All" }),
            path:"/user/points-history/all"
        },
        {
            id:2,
            title: Intl.formatMessage({ id: "recived", defaultMessage: "Recived" }),
            path:"/user/points-history/recived"
        },
        {
            id:3,
            title: Intl.formatMessage({ id: "used", defaultMessage: "Used" }),
            path:"/user/points-history/used"
        },
        {
            id: 4,
            title: Intl.formatMessage({ id: "expired", defaultMessage: "Expired" }),
            path:"/user/points-history/expired"
        }
    ]);

    const tabActive = useCallback((pathname, path)=>{
        return pathname?.indexOf(path) >= 0
    },[]);

    return <div className={cls.PointsHistoryTab}>
        {
          initDataRef.current?.map((tab, index) =>{
            return <div className={cls.TabItem} key={tab.id+index}>
                <Link to={tab.path} replace>
                    <span className={tabActive(location.pathname, tab.path)?cls.Active:""}>{tab.title}</span>
                </Link>
            </div>
          })  
        }
    </div>
}

export default props =>{
    useStyles(cls);
    const Intl = useIntl();

    return <div className={cls.PointsHistoryLayout}>
        <Header 
            centerSlot={`${Intl.formatMessage({ id: "points_history", defaultMessage: "Points History" })}`} 
        />

        <Affix offsetTop={44}>
            <PointsHistoryTab />
            <div className={cls.Border}></div>
        </Affix>
        

        {props?.children}
    </div>
}